import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {Dispatch, SetStateAction} from 'react';

import {getBenchlingAppConfigurationQuery} from 'benchling-apps/configuration/__generated/getBenchlingAppConfigurationQuery';
import RunSchemaDropdown from 'benchling-apps/interactivity/features/RunSchemaDropdown';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {FONT_FAMILY_PROXIMA} from 'styles/FontConstants';
import {GRAY, GRAY_DARKER} from 'ui-library/Colors';

import {ResourceFeatureAssociation} from './types';

type Feature = ExtractByTypename<
  getBenchlingAppConfigurationQuery['benchlingApp'],
  'BenchlingAppNode'
>['features'][number];

export default function FeatureConfigurationBlock({
  features,
  appName,
  appId,
  resourceFeatureAssociations,
  updateResourceFeatureAssociations,
}: {
  features: Array<Feature>;
  appName: string;
  appId: string;
  resourceFeatureAssociations: Array<ResourceFeatureAssociation>;
  updateResourceFeatureAssociations: Dispatch<SetStateAction<Array<ResourceFeatureAssociation>>>;
}): JSX.Element | null {
  return features.length === 0 ? (
    <></>
  ) : (
    <div className={classNames(css(styles.configurations))}>
      <div className={classNames(css(styles.headerStyle))}>Feature Configurations</div>
      <div className={classNames(css(styles.helperText))}>
        Use additional app features by filling out their configurations.
      </div>
      <div className={classNames(css(styles.configCard))}>
        {features.map((feature, i) => (
          <div key={i}>
            <RunSchemaDropdown
              feature={feature}
              appName={appName}
              appId={appId}
              resourceFeatureAssociations={resourceFeatureAssociations}
              updateResourceFeatureAssociations={updateResourceFeatureAssociations}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  configurations: {
    padding: '16px 24px',
  },
  configCard: {
    marginTop: '10px',
    overflow: 'scroll',
    paddingRight: '10px',
    '::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      width: '7px',
    },
    '::-webkit-scrollbar-thumb': {
      'border-radius': '4px',
      'background-color': GRAY,
    },
  },
  headerStyle: {
    fontFamily: FONT_FAMILY_PROXIMA,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
  },
  helperText: {
    color: GRAY_DARKER,
  },
});
